import React from "react";
import Container from "./container";
import MediaCopyBlock from "./media-copy-block";
import { cn } from "../lib/helpers";

import * as styles from "../styles/components/fc-media-copy-blocks.module.css";

interface MediaAsset {
  asset?: {
    _id?: string;
    url?: string;
    originalFilename?: string;
  };
  alt?: string;
}

interface MediaVideo {
  mp4?: MediaAsset;
  webm?: MediaAsset;
}

interface Media {
  image?: MediaAsset;
  video?: MediaVideo;
}

interface ButtonType {
  blank?: boolean;
  text?: string;
  url?: string;
}

interface BlockItem {
  _key?: string;
  title?: string;
  _rawCopy?: any[];
  button?: ButtonType;
  media?: Media;
}

interface MediaCopyBlocksProps {
  blocks?: BlockItem[];
}

const MediaCopyBlocks: React.FC<MediaCopyBlocksProps> = ({ blocks }) => {
  if (!blocks || blocks.length === 0) {
    return null;
  }

  return (
    <div className={styles.root}>
      <Container>
        {blocks.map((node) => (
          <MediaCopyBlock {...node} key={node._key} />
        ))}
      </Container>
    </div>
  );
};

export default MediaCopyBlocks;
